import {
  isDate,
  isEmpty
} from 'lodash';
import { stripNilProps } from './common.utilities';

type ScrubbableVal = string | number | Date | boolean | string[];
type ScrubbedVal = string | number | string[];

export const scrubProps = (obj: Record<string, ScrubbableVal>): Record<string, ScrubbedVal> => {
  if (!obj || isEmpty(obj)) {
    return {};
  }
  const copy = stripNilProps(obj) as Record<string, ScrubbableVal>;
  Object.keys(copy).forEach((key) => {
    if (copy[key] === '') {
      delete copy[key];
    } else if (copy[key] === true || copy[key] === false) {
      copy[key] = copy[key].toString();
    } else if (isDate(copy[key])) {
      copy[key] = (copy[key] as Date).getTime();
    } else if (typeof copy[key] === 'string' && !Number.isNaN(Number(copy[key]))) {
      copy[key] = parseFloat(copy[key] as string);
    }
  });
  return copy as Record<string, ScrubbedVal>;
};
